<div class="flex w-full py-6 bg-white sm:p-6 sm:gap-5 sm:border sm:rounded-lg">
	<div class="hidden p-4 text-white rounded-md bg-uc-blue-900 h-max sm:block">
		<ng-content></ng-content>
	</div>
	<div class="flex items-center justify-between flex-grow sm:block">
		<p class="text-sm font-medium text-gray-500">{{ cardTitle() }}</p>
		<p class="text-base font-medium text-gray-900 sm:text-xl sm:font-semibold">
			{{ value() && value() !== '0' ? value() : 'Varied' }}
		</p>
	</div>
</div>
